export enum TeamStatusEnum {
    ACTIVE          = 1,
    NOT_ACTIVE      = 2,
}
